// models/metrics/metasearchMetrics/skyscanner/skyscannerMetrics.js

// conversion
import MetricBookingcount from "models/metrics/metasearchMetrics/skyscanner/conversion/MetricBookingcount";
import MetricConversionSkyscanner from "models/metrics/metasearchMetrics/skyscanner/conversion/MetricConversion";
import MetricRevenuePerclickSkyscanner from "models/metrics/metasearchMetrics/skyscanner/conversion/MetricRevenuePerclick";
import MetricRoiSkyscanner from "models/metrics/metasearchMetrics/skyscanner/performance/MetricRoi";

// performance
import MetricClicksSkyscanner from "models/metrics/metasearchMetrics/skyscanner/performance/MetricClicks";
import MetricCpcSkyscanner from "models/metrics/metasearchMetrics/skyscanner/performance/MetricCpc";
import MetricCsrSkyscanner from "models/metrics/metasearchMetrics/skyscanner/performance/MetricCsr";
import MetricGeneratedSkyscanner from "models/metrics/metasearchMetrics/skyscanner/performance/MetricGenerated";
import MetricSpentSkyscanner from "models/metrics/metasearchMetrics/skyscanner/performance/MetricSpent";

// visibility

const skyscannerMetrics = [
    // conversion
    new MetricBookingcount(),
    new MetricConversionSkyscanner(),
    new MetricRevenuePerclickSkyscanner(),
    new MetricRoiSkyscanner(),
    // performance
    new MetricClicksSkyscanner(),
    new MetricCpcSkyscanner(),
    new MetricCsrSkyscanner(),
    new MetricGeneratedSkyscanner(),
    new MetricSpentSkyscanner(),
    // visibility
];

export function findMetricById(metricId) {
    return skyscannerMetrics.find((metricClass) => metricClass.field === metricId);
}

export default skyscannerMetrics;
